module.exports = __webpack_public_path__ + "img/bj-sprite-grid.42061412.jpg";